import React from 'react';

import { useTranslation } from 'react-i18next';

import { Sheet } from '@pkg/components';
import { useFilteredItems, useGroupId } from '@pkg/hooks';

import { NftList, type NftListProps } from '../../components';

export interface SearchResultsProps {
    value?: NftListProps['searchValue'];
}

export function SearchResults({ value }: SearchResultsProps) {
    const { t: translate } = useTranslation('groups');

    const groupId = useGroupId();
    const { items, isLoading, isError, hasNextPage, isFetching, isPreviousData, fetchNextPage } = useFilteredItems({
        groupId,
    });

    // TODO: Let's fix the data response to avoid this.
    const pluckedItems = items.map(({ item }) => item);

    // TODO: Remove `leadingSpace` once we have a better implementation for
    // providing a space before an opened `Search`.
    return (
        <Sheet.Layout>
            <Sheet.Layout.Header title={translate('pods_image_search_title')} leadingSpace />

            <Sheet.Layout.Columns stretch>
                <Sheet.Layout.Columns.Primary padded scrollable>
                    <NftList
                        items={pluckedItems}
                        searchValue={value}
                        loading={isLoading}
                        hasError={isError}
                        hasMoreResults={hasNextPage}
                        fetchingResults={isFetching}
                        staleResults={isPreviousData}
                        onLoadMore={fetchNextPage}
                    />
                </Sheet.Layout.Columns.Primary>
            </Sheet.Layout.Columns>
        </Sheet.Layout>
    );
}
